import { useReducerState, useCallback, useEffect, useFeatures } from 'sb-hooks'
import { mixpanel, constants, formatPrice } from 'common/helpers'
import actions from 'redux/actions'
import moment from 'moment'

import messages from '../messages'


const initialState = {
  isFetching: false,
  planData: {},
  isSuccess: false,
}

export const useSelectedPlan = ({ plan: { name: planName, productsPerPeriod }, intl, onClose }) => {
  const [
    { isFetching, planData, isSuccess },
    setState,
  ] = useReducerState(initialState)

  const {
    upgradeActivationDate, chargeCategory, nextBillingYearMonth, balance, tax, price,
    inquirePlan = {},
  } = planData

  const { totalPrice } = inquirePlan

  const billItems = [
    {
      label: {
        ...messages.planName,
        values: { productsPerPeriod },
      },
      value: formatPrice(totalPrice, true),
    },
    {
      label: messages.currBalance,
      value: formatPrice(-balance, true),
      tooltip: messages.balanceTooltipText,
    },
    {
      label: messages.tax,
      value: formatPrice(tax, true),
    },
    {
      label: messages.shipping,
      value: intl.formatMessage(messages.free),
    },
  ]

  const handleContinueClick = useCallback(() => {
    setState({ isFetching: true })

    actions.models.subscription.changePlan(planName, 'thankyou page')
      .then(() => setState({ isSuccess: true, isFetching: false }))
      .finally(() => setState({ isFetching: false }))
  }, [ planName ])

  const dateFormat = 'MMMM'

  let upgradeActivationMonth
  let nextChargeMonth

  if (upgradeActivationDate) {
    upgradeActivationMonth = moment(upgradeActivationDate).format(dateFormat)
  }

  if (nextBillingYearMonth && chargeCategory === constants.upgradeSubscriptionTypes.nonCharge) {
    nextChargeMonth = moment(nextBillingYearMonth).format(dateFormat)
  }

  useEffect(() => {
    setState({ isFetching: true })

    actions.models.subscription.fetchPlanCosts(planName)
      .then((planData) => setState({ isFetching: false, planData }))
      .catch(() => onClose())
      .finally(() => setState({ isFetching: false }))
  }, [])

  return {
    isFetching,
    isSuccess,
    upgradeActivationMonth,
    nextChargeMonth,
    billItems,
    handleContinueClick,
    total: price,
  }
}
